module.exports = __webpack_public_path__ + "img/stanly.7f8aaa86.png";